module.exports = __webpack_public_path__ + "static/media/2.3db3c8bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 75
// module chunks = 0